import { NgModule, Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { finalize } from 'rxjs/operators';
import { UserRoleApi, RoleDataApi, RoleData } from '../../../../assets/js/lb-sdk';
import { MERCHANT_TYPE, PAYMENT_TYPE } from '../../../enums';

interface ChangeMerchantTypeForm {
  id?: number,
  merchantType?: string,
  paymentType?: string,
  previousMerchantType?: string,
  previousPaymentType?: string,
  roleId?: string
};

@Component({
  selector: 'app-change-merchant-type',
  templateUrl: './change-merchant-type.component.html',
  styleUrls: ['./change-merchant-type.component.css']
})
export class ChangeMerchantTypeComponent implements OnInit {
  data: ChangeMerchantTypeForm;
  error: string;
  loading: boolean = false;
  MERCHANT_TYPE: typeof MERCHANT_TYPE = MERCHANT_TYPE;
  PAYMENT_TYPE: typeof PAYMENT_TYPE = PAYMENT_TYPE;

  constructor(
    public modal: BsModalRef,
    private userRoleApi: UserRoleApi,
    private roleDataApi: RoleDataApi
  ) { }

  ngOnInit() {
    this.data = this.data ? {
      ...this.data,
      previousMerchantType: this.data.merchantType,
      previousPaymentType: this.data.paymentType
    } : {};
  }

  dismiss(reason: string) {
    this.modal.content.reason = reason;
    this.modal.hide();
  }

  close(form) {
    this.error = undefined;
    if (form.valid) {
      this.loading = true;
      this.roleDataApi
        .findOne({
          where: { code: this.data.merchantType }
        })
        .pipe(finalize(() => {
          this.loading = false;
        }))
        .subscribe((role:RoleData) => {
          this.loading = true;
          this.userRoleApi
            .patchAttributes(this.data.roleId, {
              principalType: this.data.merchantType,
              paymentType: this.data.paymentType,
              roleId: role.id
            })
            .pipe(finalize(() => {
              this.loading = false;
            }))
            .subscribe(() => {
              this.modal.content.result = 'done';
              this.modal.hide();
            },
            error => {
              this.error = 'Failed to update merchant type';
            });
        },
        error => {
          this.error = 'Failed to load role details. Try again';
        })
    }
  }
}
